/* Global imports */
import { getIn, useField, useFormikContext } from 'formik'
import * as React from 'react'
import { FormikFieldConfigProps } from 'scenes/Dashboard/components-next/Forms/helper'

/* Local imports */
import { TagsInput, TagsInputProps } from './TagsInput.component'

/* Types  */

type TagsInputFieldProps = FormikFieldConfigProps & Omit<TagsInputProps, 'name'>

/* Local utility functions */

/* Component definition */
export const TagsInputField = React.forwardRef<HTMLInputElement, TagsInputFieldProps>((props, ref) => {
  const { validate, name, type, innerRef, onChange, onBlur, disabled, handleSelectedTags, ...otherProps } = props
  const fieldProps = React.useMemo(() => ({ validate, name, innerRef }), [validate, name, innerRef])
  const [field] = useField<any>(fieldProps)
  const { errors, isSubmitting, setFieldValue } = useFormikContext()
  const { value, onChange: handleFormikChange, onBlur: handleFormikBlur } = field
  const error = getIn(errors, name)

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<any>) => {
      if (onChange) {
        onChange(e)
      }
      handleFormikChange(e)
    },
    [handleFormikChange, onChange]
  )
  const handleBlur = React.useCallback(
    (e: React.FocusEvent<any>) => {
      // FIXME: Why blur comes without event
      if (!e.target) {
        e.target = { name, value }
      }
      if (onBlur) {
        onBlur(e)
      }
      handleFormikBlur(e)
    },
    [handleFormikBlur, name, onBlur, value]
  )
  return (
    <TagsInput
      name={name}
      tags={value}
      handleSelectedTags={(items) => {
        setFieldValue(name, items)
      }}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      disabled={isSubmitting || disabled}
      ref={ref}
      {...otherProps}
    />
  )
})

TagsInputField.displayName = 'TagsInputField.formik'

/* Styles */
